export const LOAD_PRODUCTS = 'load_products';
export const PRODUCTS_LOADED = 'set_loaded_products';
export const RESET_PRODUCTS = 'reset_products';
export const SYNC_FAILED = 'products_sync_error';
